import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import f1 from "../assets/foto/gallery-1.jpg";
import f2 from "../assets/foto/gallery-2.jpg";
import f3 from "../assets/foto/gallery-3.jpg";
import f4 from "../assets/foto/gallery-4.jpg";
import f5 from "../assets/foto/gallery-5.jpg";
import f6 from "../assets/foto/gallery-6.jpg";

const images = [
  f1,
  f2,
  f3,
  f4,
  f5,
  f6,
];

const slides = images.map((src) => ({
  src,
}));

function Gallery() {
  const [index, setIndex] = useState(-1);
  const { t } = useTranslation();

  return (
    <section id="gallery" className="gallery-section">

      <div>
        <div className="gallery-header">
          <h2 className="base-title">
            {t("gallery.title")}
          </h2>

          <p className="base-subtitle">
            {t("gallery.subtitle")}
          </p>
        </div>
      </div>

      <div className="gallery-grid">
        {images.map((src, index) => (
          <div
            key={index}
            className="cursor-pointer rounded-lg overflow-hidden aspect-[4/3] bg-gray-100"
            onClick={() => setIndex(index)}
          >
            <img
              src={src}
              alt=""
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-200"
            />
          </div>
        ))}
      </div>

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        index={index}
        slides={slides}
        plugins={[Zoom]}
      />

    </section>
  );
}

export default Gallery;